import { render, staticRenderFns } from "./MainPageRunningHourNewDetail.vue?vue&type=template&id=19002750&scoped=true"
import script from "./MainPageRunningHourNewDetail.vue?vue&type=script&lang=js"
export * from "./MainPageRunningHourNewDetail.vue?vue&type=script&lang=js"
import style0 from "./MainPageRunningHourNewDetail.vue?vue&type=style&index=0&id=19002750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19002750",
  null
  
)

export default component.exports